import { IStatusValue } from '../../../shared/components/gmc-status-input/gmc-status-input.component';

export class PersonalRegData {
  first_name = '';
  last_name = '';
  password = '';
  country = '';
  city = '';
  username = '';
  personal_email: IStatusValue[];
  personal_phone: IStatusValue[];

  constructor() {
    this.personal_email = [ {} ];
    this.personal_phone = [ {} ];
  }
}



// WEBPACK FOOTER //
// ./app/states_mobile/auth/models/personal-reg-data.ts